/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconScale = createReactComponent("outline", "scale", "IconScale", [["path", { "d": "M7 20l10 0", "key": "svg-0" }], ["path", { "d": "M6 6l6 -1l6 1", "key": "svg-1" }], ["path", { "d": "M12 3l0 17", "key": "svg-2" }], ["path", { "d": "M9 12l-3 -6l-3 6a3 3 0 0 0 6 0", "key": "svg-3" }], ["path", { "d": "M21 12l-3 -6l-3 6a3 3 0 0 0 6 0", "key": "svg-4" }]]);

export { IconScale as default };
//# sourceMappingURL=IconScale.mjs.map
